var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigifiAuthLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4189 36.9974L38.0854 30.7285C38.349 30.2553 38.349 29.6876 38.0854 29.2381L36.9351 27.251L30.8003 37.7544H33.1248C33.652 37.7544 34.1553 37.4706 34.4189 36.9974Z",
    fill: "url(#auth_logo_white_paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0263 36.9972L40.913 35.5068C41.1766 35.0337 41.1766 34.4659 40.913 34.0165L39.7627 32.053L36.4077 37.7778H38.7323C39.2355 37.7542 39.7388 37.4703 40.0263 36.9972Z",
    fill: "url(#auth_logo_white_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2382 37.7544L4.10336 27.251L2.95308 29.2381C2.68947 29.7112 2.68947 30.279 2.95308 30.7285L6.59564 36.9974C6.85925 37.4706 7.3625 37.7544 7.91368 37.7544H10.2382Z",
    fill: "url(#auth_logo_white_paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34799 31.9583L0.197705 33.9217C-0.0659018 34.3949 -0.0659018 34.9626 0.197705 35.4121L1.10835 36.9971C1.37196 37.4702 1.87521 37.7541 2.42638 37.7541H4.75092L1.34799 31.9583Z",
    fill: "url(#auth_logo_white_paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0132 37.7542H27.5164C28.0676 37.7542 28.5709 37.4703 28.8345 36.9972L35.3048 25.926C35.5684 25.4529 35.5684 24.8851 35.3048 24.4356L34.1545 22.4485L26.1025 36.1929L27.0132 37.7542Z",
    fill: "url(#auth_logo_white_paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8223 37.7542L7.79428 24.0098H5.97299L5.73335 24.4592C5.46974 24.9324 5.46974 25.5001 5.73335 25.9496L12.2037 36.9972C12.4673 37.4703 12.9706 37.7542 13.5217 37.7542H15.8223Z",
    fill: "url(#auth_logo_white_paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9049 34.158L32.5016 21.1706C32.7652 20.6975 32.7652 20.1297 32.5016 19.6803L31.3513 17.6931L23.3232 31.4375L24.9049 34.158Z",
    fill: "url(#auth_logo_white_paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1904 24.0098L17.7871 36.9972C18.0507 37.4703 18.554 37.7542 19.1051 37.7542H21.4297L13.3777 24.0098H10.1904Z",
    fill: "url(#auth_logo_white_paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9861 24.0098H15.7749L23.3716 36.9972C23.6352 37.4703 24.1384 37.7542 24.6896 37.7542H27.0142L18.9861 24.0098Z",
    fill: "url(#auth_logo_white_paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1857 6.95361H16.8526C16.3015 6.95361 15.8222 7.23749 15.5346 7.71062L14.3604 9.67411H26.654L25.5037 7.68696C25.2162 7.23749 24.7129 6.95361 24.1857 6.95361Z",
    fill: "url(#auth_logo_white_paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4297 2.22217H19.6085C19.0573 2.22217 18.578 2.50605 18.2904 2.97917L17.1401 4.96632H23.8981L22.7478 2.97917C22.4842 2.50605 21.9809 2.22217 21.4297 2.22217Z",
    fill: "url(#auth_logo_white_paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5478 12.9152L28.2842 12.4894C28.0206 12.0163 27.5174 11.7324 26.9662 11.7324H14.0255C13.4743 11.7324 12.995 12.0163 12.7074 12.4894L11.5571 14.4766H27.6372L28.5478 12.9152Z",
    fill: "url(#auth_logo_white_paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4395 16.5105H11.2462C10.695 16.5105 10.2157 16.7944 9.92812 17.2675L8.77783 19.2547H24.8579L26.4395 16.5105Z",
    fill: "url(#auth_logo_white_paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14691 22.0226L5.97266 24.0098H22.0527L23.6583 21.2656H8.46494C7.91376 21.2893 7.41051 21.5732 7.14691 22.0226Z",
    fill: "url(#auth_logo_white_paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5476 12.915L20.5195 26.6594L22.1251 29.4036L29.7218 16.4162C29.9854 15.9431 29.9854 15.3753 29.7218 14.9258L28.5476 12.915Z",
    fill: "url(#auth_logo_white_paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6918 10.335C64.911 10.335 68.7894 13.7774 68.7894 19.6582C68.7894 25.5391 64.8391 28.9815 59.6439 28.9815H52.2222V10.335H59.6918ZM55.1669 26.4236H59.6679C63.283 26.4236 65.8207 24.1047 65.8207 19.6582C65.8207 15.2117 63.3309 12.869 59.6918 12.869H55.1669V26.4236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3738 11.7456C75.3738 12.7257 74.5838 13.4907 73.6022 13.4907C72.6446 13.4907 71.8545 12.7018 71.8545 11.7456C71.8545 10.7894 72.6446 10.0005 73.6022 10.0005C74.5838 10.0005 75.3738 10.7894 75.3738 11.7456ZM72.2136 28.9578V16.1921H75.0147V28.9817L72.2136 28.9578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6126 17.9846V16.1917H91.2461V29.6029C91.2461 33.2605 88.7563 35.5554 84.9496 35.5554C81.143 35.5554 79.084 33.6429 78.5813 30.8699L81.3824 30.7742C81.6218 32.2564 83.0104 33.1887 84.8778 33.1887C87.0086 33.1887 88.445 32.0174 88.445 29.7941V27.4513C87.7507 28.4554 86.2903 29.2204 84.375 29.2204C80.8078 29.2204 78.2222 26.6864 78.2222 22.5985C78.2222 18.5106 80.8318 15.9766 84.399 15.9766C86.3861 15.9766 87.9183 16.8133 88.6126 17.9846ZM81.0712 22.5985C81.0712 25.3237 82.6752 26.8298 84.8299 26.8298C86.9367 26.8298 88.445 25.4672 88.445 22.9331V22.2638C88.445 19.7298 86.9128 18.3671 84.8299 18.3671C82.6752 18.391 81.0712 19.8732 81.0712 22.5985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4041 11.7456C98.4041 12.7257 97.6141 13.4907 96.6325 13.4907C95.6748 13.4907 94.8848 12.7018 94.8848 11.7456C94.8848 10.7894 95.6748 10.0005 96.6325 10.0005C97.6141 10.0005 98.4041 10.7894 98.4041 11.7456ZM95.2439 28.9578V16.1921H98.045V28.9817L95.2439 28.9578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18 12.9412V18.1526H112.41V20.7584H105.18V28.958H102.211V10.3115H113.943V12.9412H105.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 11.7457C120 12.7258 119.21 13.4908 118.228 13.4908C117.271 13.4908 116.48 12.7019 116.48 11.7457C116.48 10.7894 117.271 10.0005 118.228 10.0005C119.21 9.97662 120 10.7655 120 11.7217C120 11.7457 120 11.7457 120 11.7457ZM116.84 28.9578V16.1921H119.641V28.9817L116.84 28.9578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint0_linear",
    x1: 41.1624,
    y1: 29.4842,
    x2: 23.091,
    y2: 38.8548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint1_linear",
    x1: 43.0138,
    y1: 33.0661,
    x2: 25.002,
    y2: 42.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint2_linear",
    x1: 5.57697,
    y1: 38.0359,
    x2: 10.4794,
    y2: 14.4722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint3_linear",
    x1: 2.1045,
    y1: 37.3352,
    x2: 6.95309,
    y2: 14.0296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint4_linear",
    x1: 39.3125,
    y1: 25.9112,
    x2: 21.2244,
    y2: 35.2915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint5_linear",
    x1: 9.10915,
    y1: 38.7599,
    x2: 14.0279,
    y2: 15.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint6_linear",
    x1: 36.9955,
    y1: 21.4414,
    x2: 18.9049,
    y2: 30.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint7_linear",
    x1: 13.9136,
    y1: 39.7459,
    x2: 18.8324,
    y2: 16.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint8_linear",
    x1: 19.2714,
    y1: 40.8461,
    x2: 24.1902,
    y2: 17.2018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint9_linear",
    x1: 12.9032,
    y1: 6.31352,
    x2: 33.608,
    y2: 12.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint10_linear",
    x1: 14.2676,
    y1: 2.00448,
    x2: 34.9724,
    y2: 8.55832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint11_linear",
    x1: 11.5279,
    y1: 10.6623,
    x2: 32.2327,
    y2: 17.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint12_linear",
    x1: 9.99304,
    y1: 15.5163,
    x2: 30.6955,
    y2: 22.0701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint13_linear",
    x1: 8.36412,
    y1: 20.6558,
    x2: 29.0665,
    y2: 27.2121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "auth_logo_white_paint14_linear",
    x1: 34.448,
    y1: 16.5352,
    x2: 16.3598,
    y2: 25.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D7E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigifiAuthLogoWhite);
export default __webpack_public_path__ + "static/media/digifi-auth-logo-white.91d0abf4.svg";
export { ForwardRef as ReactComponent };